import { getIsWhatsAppCampaign } from 'modules/campaigns/lib/utils';
import { TemplateEditViews } from 'modules/templateEditor/common';
import { useTemplateTakeover } from 'modules/templateEditor/integrations/InStudioTemplateEditing/context';
import { PrimaryButton, SecondaryButton } from 'ui/button';
import { TemplateEmptyState } from 'ui/illustrations';
import { useCampaignContext } from '../../context/CampaignContext/CampaignContext';
import {
  Buttons,
  CampaignTemplateContainer,
  TemplateContentBody,
  TemplateContentContainer,
  TemplateContentTitle,
} from './TemplateContent.styles';

export const NewTemplate = () => {
  const takeover = useTemplateTakeover();
  const {
    campaign: { messageMedium },
  } = useCampaignContext();
  const isWhatsAppCampaign = getIsWhatsAppCampaign(messageMedium);

  return (
    <CampaignTemplateContainer>
      <TemplateEmptyState />
      <TemplateContentContainer>
        <TemplateContentTitle>Design your campaign content</TemplateContentTitle>
        <TemplateContentBody>
          {isWhatsAppCampaign
            ? 'Select your campaign content from existing approved business-initiated templates.'
            : 'Create campaign content from an existing template or start a new design for this campaign.'}
        </TemplateContentBody>
      </TemplateContentContainer>
      <Buttons id="template-selection-buttons">
        {!isWhatsAppCampaign && (
          <SecondaryButton onClick={() => takeover.open(TemplateEditViews.content)}>
            Start from scratch
          </SecondaryButton>
        )}
        <PrimaryButton onClick={() => takeover.open(TemplateEditViews.select)}>
          Browse templates
        </PrimaryButton>
      </Buttons>
    </CampaignTemplateContainer>
  );
};
